import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectTag = simpleSet as
  redux.reducers.calculationMode.settings.information.tag;

export const tag = setCalculationModeProjectTag(
  'SET_CALCULATION_MODE_PROJECT_TAG',
  'estimating'
);
